import { render, staticRenderFns } from "./PageRows.vue?vue&type=template&id=5c805b22"
import script from "./PageRows.vue?vue&type=script&lang=js"
export * from "./PageRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports